var map = {
	"./Template 1": [
		7361,
		9,
		372,
		361
	],
	"./Template 1/": [
		7361,
		9,
		372,
		361
	],
	"./Template 1/QR.module.scss": [
		1391,
		9,
		391
	],
	"./Template 1/index": [
		7361,
		9,
		372,
		361
	],
	"./Template 1/index.jsx": [
		7361,
		9,
		372,
		361
	],
	"./Template 1/screenshot.png": [
		3575,
		1
	],
	"./Template 1/template_meta": [
		3366,
		3
	],
	"./Template 1/template_meta.json": [
		3366,
		3
	],
	"./Template 2": [
		5186,
		9,
		372,
		186
	],
	"./Template 2/": [
		5186,
		9,
		372,
		186
	],
	"./Template 2/QR.module.scss": [
		7926,
		9,
		926
	],
	"./Template 2/index": [
		5186,
		9,
		372,
		186
	],
	"./Template 2/index.jsx": [
		5186,
		9,
		372,
		186
	],
	"./Template 2/screenshot.png": [
		5202,
		1
	],
	"./Template 2/template_meta": [
		5683,
		3
	],
	"./Template 2/template_meta.json": [
		5683,
		3
	],
	"./Template 3": [
		231,
		9,
		372,
		231
	],
	"./Template 3/": [
		231,
		9,
		372,
		231
	],
	"./Template 3/QR.module.scss": [
		6413,
		9,
		413
	],
	"./Template 3/index": [
		231,
		9,
		372,
		231
	],
	"./Template 3/index.jsx": [
		231,
		9,
		372,
		231
	],
	"./Template 3/screenshot.png": [
		3685,
		1
	],
	"./Template 3/template_meta": [
		9376,
		3
	],
	"./Template 3/template_meta.json": [
		9376,
		3
	],
	"./Template 4": [
		8008,
		9,
		372,
		8
	],
	"./Template 4/": [
		8008,
		9,
		372,
		8
	],
	"./Template 4/QR.module.scss": [
		7228,
		9,
		228
	],
	"./Template 4/index": [
		8008,
		9,
		372,
		8
	],
	"./Template 4/index.jsx": [
		8008,
		9,
		372,
		8
	],
	"./Template 4/screenshot.png": [
		8944,
		1
	],
	"./Template 4/template_meta": [
		6669,
		3
	],
	"./Template 4/template_meta.json": [
		6669,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1215;
module.exports = webpackAsyncContext;